import { Controller } from "@hotwired/stimulus";
import { rrFetch } from "../utils/rr_fetch";
import toast from "../utils/toast";

// cash-reveal: unlocks the pickup code on the "Ready to Collect" screen. The code is
// a bearer secret, so it is NOT in the page — this fetches it from the backend on an
// explicit tap and shows the text only (there is no QR; the framed area is a scanner).
export default class CashRevealController extends Controller {
  static targets = ["codeMasked", "codeReveal", "codeText", "copy"];
  static values = { revealUrl: String };

  async reveal(event) {
    if (event) event.preventDefault();
    if (this._revealed || !this.hasRevealUrlValue) return;

    try {
      const response = await rrFetch(this.revealUrlValue, {
        method: "GET",
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      const data = await response.json();
      const code = data?.code || "";
      if (!code) throw new Error("empty code");
      this._revealed = true;
      if (this.hasCodeTextTarget) this.codeTextTarget.textContent = code;
      if (this.hasCopyTarget) this.copyTarget.setAttribute("data-copy-text-value", code);
      if (this.hasCodeMaskedTarget) this.codeMaskedTarget.classList.add("hidden");
      if (this.hasCodeRevealTarget) this.codeRevealTarget.classList.remove("hidden");
    } catch (error) {
      toast("Couldn't reveal the code. Please try again.", "error");
    }
  }
}
